import "./memberPayslip.css";
import React, { createRef, useEffect, useRef, useState } from "react";
import close from "../../images/icons/close.png";
import view from "../../images/icons/view.png";
import CustomSearchBar from "../../components/CustomSearchBar/CustomSearchBar";
import apiUtil from "../../api/apiUtil";
import { Box } from "@material-ui/core";
import Table from "../../components/Table/Table";
import api from "../../api/api";
import getToken, { redirectToLogin } from "../getToken";
import authStore from "../../store/authStore";
import { format, parseISO } from 'date-fns';
import { toPng } from "html-to-image";
import { message } from "antd";

const MemberPayslip = () => {
    const refPayslipTable = createRef();
    const payslipId = useRef(0);
    const payslipRef = useRef(null);
    const [isView, setIsView] = useState(false);
    const [keyword, setKeyword] = useState("");
    const [isProcessing, setIsProcessing] = useState(false);

    const generateAndCopyPayslip = async () => {

        if (!payslipRef.current) return;

        setIsProcessing(true); // Disable button while processing

        try {
            // Generate the image
            const imageUrl = await toPng(payslipRef.current, {
                quality: 1,
                pixelRatio: 2, // High resolution but reasonable size
            });

            // Copy image to clipboard
            if (!navigator.clipboard || typeof ClipboardItem === "undefined") {
                message.error("Clipboard API is not supported in your browser.");
                setIsProcessing(false);
                return;
            }

            const response = await fetch(imageUrl);
            const blob = await response.blob();
            const clipboardItem = new window.ClipboardItem({ "image/png": blob });
            await navigator.clipboard.write([clipboardItem]);

            message.success("Payslip copied to clipboard!");
        } catch (error) {
            console.error("Error generating/copying payslip:", error);
            message.error("Failed to generate or copy payslip.");
        }

        setIsProcessing(false); // Re-enable button
    };

    const [detailPayslip, setDetailPayslip] = useState({
        expoId: "",
        expoName: "",
        memberId: "",

        lotName: [],
        serviceName: [],
        rate: [],
        weight: [],
        price: [],
        saleAmount: [],

        markerName: "",
        percentage: "",
        serviceFee: "",
        totalPrice: "",
        totalSaleAmount: "",
        description: "",
        payslipId: "",
        brandId: "",

        carryFeeList: [],
        protectionPriceList: [],
        refundPriceList: [],
        colorEnhancedFeeList: [],
        depositList: []
    });

    const brandId = authStore((state) => state.auth?.brandId);

    const clickViewPayslip = async (rowData) => {
        setIsView(true);
        await getPayslipDetail(rowData.expoId, rowData.memberId);
    };

    const clickBtnCloseForm = () => {
        setIsView(false);
    };


    const [payslipList, setPayslipList] = useState({
        isLoading: false,
        grouping: false,
        limit: apiUtil.getDefaultPageSize(),
        data: [],
        total: 0,
        page: 1,
    });

    const [paramPayslip, setParamPayslip] = useState({
        keyword: "",
        rowLimit: 10,
        currentPage: 1,
        sortBy: "",
        isDesc: true,
        brandId: brandId,
    });

    const retrievePayslipList = async (value = paramPayslip) => {
        const request = {
            ...value,
            keyword: value.keyword || "",
        };

        try {
            setPayslipList((prev) => ({
                ...prev,
                isLoading: true,
            }));

            const result = await api.post(
                "Admin/GetMemberPayslipList",
                request,
                getToken()
            );

            apiUtil.parseResult(
                result,
                (response) => {
                    const { code, data } = response.data;

                    if (code === 401) {
                        message.error(response.data.message);

                        redirectToLogin();

                        return;
                    }
                    if (code === 200) {
                        setPayslipList((prev) => ({
                            ...prev,
                            isLoading: false,
                            limit: data.rowLimit,
                            data: data.data?.length ? data.data : [],
                            total: data.totalRecords,
                            page: data.paging,
                        }));
                        setTimeout(() => {
                            window.scrollTo({ top: 0, behavior: "smooth" });
                        }, 0);
                        return;
                    }

                    setPayslipList((prev) => ({
                        ...prev,
                        isLoading: false,
                        data: [],
                        total: 0,
                        page: 0,
                        limit: 0,
                    }));

                    message.warning(response.data.message);

                },
                (error) => {

                    console.error(error);

                    message.error("Failed to load payslip list.");

                    setPayslipList((prev) => ({
                        ...prev,
                        isLoading: false,
                        data: [],
                        total: 0,
                        page: 0,
                        limit: 0,
                    }));
                }
            );

        } catch (error) {
            console.error(error);
            message.error("Failed to load payslip list.");

            setPayslipList((prev) => ({
                ...prev,
                isLoading: false,
                data: [],
                total: 0,
                page: 0,
                limit: 0,
            }));
        }
    };

    const getPayslipDetail = async (expoId, memberId) => {
        try {

            const result = await api.get(
                "Admin/GetMemberPayslipDetail",
                {
                    expoId,
                    memberId
                },
                getToken()
            );

            apiUtil.parseResult(
                result,
                (response) => {
                    const { code, data } = response.data;
                    if (code === 401) {
                        message.error(response.data.message);

                        redirectToLogin();

                        return;
                    }

                    if (code === 200) {
                        setDetailPayslip(data);
                        setIsView(true);
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                        });

                        return;
                    }

                    message.warning(
                        response.data.message ||
                        "Error loading payslip detail"
                    );
                },
                (error) => {
                    console.error(error);
                    message.error(
                        "Failed to load payslip detail."
                    );
                }
            );
        } catch (error) {
            console.error(error);
            message.error(
                "Failed to load payslip detail."
            );
        }
    };

    useEffect(() => {
        retrievePayslipList({
            ...paramPayslip,
            keyword
        });
    }, [paramPayslip.currentPage]);

    return (
        <>
            {isView && (
                <>
                    <div className="Actions space_between">
                        <h6 className="title_text mt-2">Payslip Detail</h6>
                        <button className="btn btnClose" onClick={clickBtnCloseForm}>
                            <img src={close} className="imgClose" alt="imgClose" />
                        </button>
                    </div>

                    {isView && (
                        <>
                            <button className="button btnGenerateCopy my-3" onClick={generateAndCopyPayslip} disabled={isProcessing}>
                                {isProcessing ? "Processing..." : "Copy Payslip"}
                            </button>

                            <div ref={payslipRef} className="memberpayslip">
                                <div class="header">
                                    <h2>SMK</h2>
                                    <div className="d-flex flex-column justify-content-center align-items-start">
                                        <p>Shine Moe Kyaw</p>
                                        <p>PAY SLIP</p>
                                    </div>
                                </div>
                                <div className="details">
                                    <div>
                                        <p>Customer: <strong>{detailPayslip.markerName}</strong></p>
                                        <p>Expo: <strong>{detailPayslip.expoName}</strong></p>
                                        <p>DateTime: <strong>{new Date().toLocaleString("en-GB")}</strong></p>
                                    </div>
                                </div>
                                <div class="payslip-table">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>Lot</th>
                                                <th>Name</th>
                                                <th>Rate</th>
                                                <th>(KG)</th>
                                                <th>Price</th>
                                                <th>Sale</th>
                                                <th>Note</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {detailPayslip.lotName.map((lot, index) => (
                                                <>
                                                    <tr key={index}>
                                                        <td></td>
                                                        <td className="lot_name">{lot}</td>
                                                        <td>{detailPayslip.serviceName[index]}</td>
                                                        <td>{detailPayslip.rate[index]}</td>
                                                        <td>{detailPayslip.weight[index]}</td>
                                                        <td>
                                                            {isNaN(detailPayslip.price[index])
                                                                ? detailPayslip.price[index]
                                                                : Number(detailPayslip.price[index]).toLocaleString()}
                                                        </td>
                                                        <td>{detailPayslip.saleAmount[index].toLocaleString()}</td>
                                                    </tr>
                                                </>
                                            ))}

                                            <tr>
                                                <td colSpan="6">Total Sale Amount</td>
                                                <td className="text-right">{detailPayslip.totalSaleAmount.toLocaleString()}</td>
                                            </tr>

                                            <tr>
                                                <td colSpan="5">Percent / Fee</td>
                                                <td>{detailPayslip.percentage}%</td>
                                                <td className="text-right">- {detailPayslip.serviceFee.toLocaleString()}</td>
                                            </tr>

                                            {detailPayslip.carryFeeList?.map((carry, index) => (
                                                <tr key={index}>
                                                    <td>{format(parseISO(carry.date), 'dd-MM-yy')}</td>
                                                    <td>ကယ်ရီခ</td>
                                                    <td></td>
                                                    <td>{carry.rate}</td>
                                                    <td>{carry.weight}</td>
                                                    <td></td>
                                                    <td className="text-right">- {carry.totalPrice.toLocaleString()}</td>
                                                    <td>{carry.description}</td>
                                                </tr>
                                            ))}

                                            {detailPayslip.protectionPriceList?.map((pp, index) => (
                                                <tr key={index}>
                                                    <td>ကာစျေး</td>
                                                    <td className="lot_name">{pp.lotName}</td>
                                                    <td>{pp.serviceName}</td>
                                                    <td>{pp.rate}</td>
                                                    <td>{pp.price}</td>
                                                    <td>{pp.percent}%</td>
                                                    <td className="text-right">- {pp.amount}</td>
                                                    <td>{pp.description}</td>
                                                </tr>
                                            ))}

                                            {detailPayslip.refundPriceList?.map((refund, index) => (
                                                <tr key={index}>
                                                    <td>လျော်ကြေး</td>
                                                    <td>{refund.lotName}</td>
                                                    <td>{refund.serviceName}</td>
                                                    <td>{refund.rate}</td>
                                                    <td>{refund.price}</td>
                                                    <td>{refund.percent}%</td>
                                                    <td className="text-right">+ {refund.amount}</td>
                                                    <td>{refund.description}</td>
                                                </tr>
                                            ))}

                                            {detailPayslip.colorEnhancedFeeList?.map((color, index) => (
                                                <tr key={index}>
                                                    <td colSpan="6">{color.description}</td>
                                                    <td className="text-right">- {color.price.toLocaleString()}</td>
                                                </tr>
                                            ))}

                                            {detailPayslip.depositList?.map((color, index) => (
                                                <tr key={index}>
                                                    <td colSpan="6">{color.description}</td>
                                                    <td className="text-right">+ {color.price.toLocaleString()}</td>
                                                </tr>
                                            ))}

                                            <tr>
                                                <td colspan="6"><strong>Total Amount</strong></td>
                                                <td className="text-right">{detailPayslip.totalPrice.toLocaleString()}</td>
                                                <td className="paid_text"><strong>{detailPayslip.description}</strong></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <footer>
                                    <p>This is a system-generated payslip</p>
                                </footer>
                            </div>
                        </>
                    )}
                </>
            )
            }

            <div className="Actions space_between">
                <h6 className="title_text mt-2">Payslip</h6>
                <div className="d-flex justify-content-end gap-16 align-items-center">
                    <CustomSearchBar
                        value={keyword}
                        setValue={setKeyword}
                        onSearch={(value) =>
                            retrievePayslipList({
                                ...paramPayslip,
                                keyword: value || "",
                                currentPage: 1
                            })
                        }
                    />
                </div>
            </div>

            <div className="table_container memberpayslip_table">
                <Table
                    ref={refPayslipTable}
                    maxBodyHeight={payslipList.limit * 100}
                    isLoading={payslipList.isLoading}
                    grouping={payslipList.grouping}
                    limit={payslipList.limit}
                    page={payslipList.page}
                    total={payslipList.total}
                    data={payslipList.data}
                    onPageChange={(page) => {
                        setParamPayslip({
                            ...paramPayslip,
                            currentPage: page,
                        });
                    }}
                    columns={[
                        {
                            title: "No",
                            render: (row) => row.tableIndex + 1
                        },
                        {
                            title: "Expo",
                            field: "expoName"
                        },
                        {
                            title: "Marker",
                            field: "markerName"
                        },
                        {
                            title: "Percentage",
                            field: "percentage"
                        },
                        {
                            title: "Service Fee",
                            render: (row) => {
                                return Number(row.serviceFee).toLocaleString();
                            }
                        },
                        {
                            title: "Total Sale",
                            render: (row) => {
                                return Number(row.totalSaleAmount).toLocaleString();
                            }
                        },
                        {
                            title: "Total Price",
                            render: (row) => {
                                return Number(row.totalPrice).toLocaleString();
                            }
                        },
                        {
                            title: "Note",
                            field: "description"
                        },
                        {
                            title: "View",
                            sorting: false,
                            render: (row) => {
                                return (
                                    <Box
                                        className="viewIcon"
                                        onClick={() => clickViewPayslip(row)}
                                    >
                                        <img src={view} alt="" className="imgIcon" />
                                    </Box>
                                );
                            },
                            width: "80px",
                            align: "center",
                        },
                    ]}
                />
            </div>
        </>
    )
}
export default MemberPayslip;
